import { del, get, post, put } from '../utils/api';
import { DepartmentResponse, UpdateJobApplicationPayload } from '../features/ApplicationData/ApplicationDataTypes';
import { formatUrl } from '../utils/urlFormatter';



const fetch_job_application_list_by_stage = '/{0}/{1}/application.listByPipeline';
const fetch_job_application_list_by_job = '/{0}/{1}/application.list';
const update_job_application_list = '/{0}/{1}/application.updateApp';
const fetch_application_details = '/{0}/{1}/{2}/application.details'
const create_team_message = '/{0}/message.addTeamMessage';
const fetch_team_messages_list = '/{0}/{1}/message.listMessages';
const update_team_message = '/{0}/{1}/message.updateMessage';
const delete_team_message = '/{0}/{1}/message.deleteMessage';

// score card 
const fetch_job_scorecard_list = '/{0}/{1}/appScorecard.listAppScorecards';
const create_app_score_card = '/{0}/appScorecard.add';
const fetch_app_score_card_details = '/{0}/{1}/appScorecard.detail';
const update_application_run_ai = '/{0}/{1}/application.runAi';
const delete_multi__application_items = '/item/{0}/deleteItems'
const update_multi_application = '/{0}/{1}/application.updateMultiApp';
const assing_interview = '/{0}/aiInterview.assign'

const credentialsConfig = {
  withCredentials: true,
}

export const fetchJobApplicationByStage = async (baseId: number, jobId: number, filters: any = {}): Promise<DepartmentResponse> => {
  // Build the query parameters from filters
  const queryParams = new URLSearchParams();

  // Add default pagination if not provided
  if (!filters.page) queryParams.append('page', '1');
  if (!filters.limit) queryParams.append('limit', '25');

  // Add all filters to query params
  Object.entries(filters).forEach(([key, value]) => {
    queryParams.append(key, value as string);
  });

  const queryString = queryParams.toString();
  const fetch_location_data = formatUrl(fetch_job_application_list_by_stage, [baseId, jobId]);
  const fullUrl = `${fetch_location_data}${queryString ? `?${queryString}` : ''}`;

  return get<DepartmentResponse>(fullUrl, credentialsConfig);
};

export const fetchJobApplicationByList = async (
  baseId: number,
  jobId: number,
  stageId: string,
  page: number = 1,
  limit: number = 25,
  filters: any = {}
): Promise<DepartmentResponse> => {
  const endpoint = formatUrl(fetch_job_application_list_by_job, [baseId, jobId]);

  const queryParamsObj: { [key: string]: string } = {
    page: page.toString(),
    limit: limit.toString(),
  };
  // Only add stage_id if it's not empty
  if (stageId) {
    queryParamsObj.stage_id = stageId;
  }
  // Add sorting if present in filters
  if (filters.orderingKey) {
    queryParamsObj.orderingKey = filters.orderingKey;
  }

  if (filters.order) {
    queryParamsObj.order = filters.order;
  }

  // Add search if present
  if (filters.search) {
    queryParamsObj.search = filters.search;
  }

  if (filters.Stages && filters.Stages.length > 0) {
    queryParamsObj.stages = filters.Stages;
  }

  if (filters['Updated By'] && filters['Updated By'].length > 0) {
    queryParamsObj.updatedBy = filters['Updated By'];
  }

  if (filters['Created at'] && filters['Created at'].length > 0) {
    queryParamsObj.createdAt = filters['Created at'];
  }

  const queryParams = new URLSearchParams(queryParamsObj).toString();

  return get<DepartmentResponse>(`${endpoint}?${queryParams}`, credentialsConfig);
};

export const fetchJobApplicationByListFilter = async (
  baseId: number,
  jobId: number,
  stageId: string,
  page: number = 1,
  limit: number = 25,
  filters: { [key: string]: string | number } = {} // Add filters as an optional parameter
): Promise<DepartmentResponse> => {
  const endpoint = formatUrl(fetch_job_application_list_by_job, [baseId, jobId]);

  // Base query parameters
  const queryParamsObj: { [key: string]: string } = {
    page: page.toString(),
    limit: limit.toString(),
  };

  // Add stage_id if it's not empty
  if (stageId) {
    queryParamsObj.stage_id = stageId;
  }

  // Add dynamic filters to query parameters
  Object.entries(filters).forEach(([key, value]) => {
    queryParamsObj[key] = value.toString();
  });

  // Construct the full URL with query parameters
  const queryParams = new URLSearchParams(queryParamsObj).toString();
  return get<DepartmentResponse>(`${endpoint}?${queryParams}`, credentialsConfig);
};



export const updateJobApplicationList = async (payload: {
  baseId: number;
  applicationId: string; // Add this
  stage_id: number;
}): Promise<DepartmentResponse> => {
  const endpoint = formatUrl(update_job_application_list, [payload.baseId, payload.applicationId]);
  return post<DepartmentResponse>(
    endpoint,
    {
      stage_id: payload.stage_id,
    },
    credentialsConfig
  );
};



export const updateJobApplicationListForApplication = async (payload: {
  baseId: number;
  applicationId: string;
  stage_id?: number;
  app_name?: string;
  app_headline?: string;
  app_location?: string;
  app_phone_number?: string;
  app_education?: string;
  app_work?: string;
  app_summary?: string;
  app_links?: string;
  app_cover_letter?: string;
  app_source?: string;
  app_source_by?: string;
  assign_to?: string;
  skills?: string;
  tag_id?:number

}): Promise<UpdateJobApplicationPayload> => {
  const endpoint = formatUrl(update_job_application_list, [payload.baseId, payload.applicationId]);
  return post<UpdateJobApplicationPayload>(
    endpoint,
    {
      // Nest the payload under a `data` key if required by the API
      stage_id: payload.stage_id,
      app_name: payload.app_name,
      app_headline: payload.app_headline,
      app_location: payload.app_location,
      app_phone_number: payload.app_phone_number,
      app_education: payload.app_education,
      app_work: payload.app_work,
      app_summary: payload.app_summary,
      app_links: payload.app_links,
      app_cover_letter: payload.app_cover_letter,
      app_source: payload.app_source,
      app_source_by: payload.app_source_by,
      assign_to: payload.assign_to,
      skills: payload.skills,
      tag_id:payload.tag_id

    },
    credentialsConfig
  );
};

export const fetchApplicationDetailsData = async (baseId: number, jobId: number, applicationId: number): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(fetch_application_details, [baseId, jobId, applicationId]);
  return get<DepartmentResponse>(fetch_location_data, credentialsConfig);
};



export const createTeamMessage = async (payload: {
  baseId: string | number | undefined;
  formData: FormData;
}): Promise<DepartmentResponse> => {
  const endpoint = formatUrl(create_team_message, [payload.baseId]);
  return post<DepartmentResponse>(
    endpoint,
    payload.formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...credentialsConfig,
    }
  );
};

export const fetchTeamMessagesList = async (payload: {
  baseId: number;
  appID: number;
  page?: number;
  limit?: number;
  type?: string;
  privacy?: string;
  user_type?: string;
  status?: string;
}): Promise<DepartmentResponse> => {
  const { baseId, appID, page = 1, limit = 25, type, privacy, user_type, status } = payload;


  const endpoint = formatUrl(fetch_team_messages_list, [baseId, appID]);
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    ...(type ? { type } : {}),
    ...(privacy ? { privacy } : {}),
    ...(user_type ? { user_type } : {}),
    ...(status ? { status } : {}),
  }).toString();


  return get<DepartmentResponse>(`${endpoint}?${queryParams}`, credentialsConfig);
};


// update team message
export const updateTeamMessage = async (
  baseId: number,
  id: number,
  messageContent: string
): Promise<DepartmentResponse> => {
  const update_teams_data = formatUrl(update_team_message, [baseId, id]); // Ensure correct URL format
  const payload = { message: messageContent }; // Correct payload format
  return put<DepartmentResponse>(update_teams_data, payload, credentialsConfig);
};

export const deleteTeamMemberMessage = async (baseId: number, id: number): Promise<DepartmentResponse> => {
  const formattedUrl = formatUrl(delete_team_message, [baseId, id]);
  return del<DepartmentResponse>(formattedUrl, credentialsConfig);
};


// score card 

export const fetchJobScorecardByList = async (
  baseId: number,
  appId: number,
  filters: any = {}
): Promise<DepartmentResponse> => {
  const endpoint = formatUrl(fetch_job_scorecard_list, [baseId, appId]);

  const queryParamsObj: { [key: string]: string } = {
    // page: page.toString(),
    // limit: limit.toString(),
  };
  // Only add stage_id if it's not empty
  // if (stageId) {
  //   queryParamsObj.stage_id = stageId;
  // }

  //scorecard_id
  if (filters.scorecard_id) {
    queryParamsObj.scorecard_id = filters.scorecard_id;
  }


  // Add search if present
  if (filters.search) {
    queryParamsObj.search = filters.search;
  }

  const queryParams = new URLSearchParams(queryParamsObj).toString();

  return get<DepartmentResponse>(`${endpoint}?${queryParams}`, credentialsConfig);
};

// app scorecard
export const createAppScoreCardData = async (baseId: number, data: any): Promise<DepartmentResponse> => {
  const base_create_app = formatUrl(create_app_score_card, [baseId]);
  return post<DepartmentResponse>(base_create_app, data, credentialsConfig);
};


export const fetchAppScoreCardDetailsData = async (baseId: number, appId: number): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(fetch_app_score_card_details, [baseId, appId]);
  return get<DepartmentResponse>(fetch_location_data, credentialsConfig);
};

// put api
export const updateApplicationAi = async (baseId: number, appId: number): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(update_application_run_ai, [baseId, appId]);
  return put<DepartmentResponse>(fetch_location_data, {}, credentialsConfig);
};

//delete_multi__application_items 
export const deleteMultiApplicationItems = async (baseId: number, itemIds: number[]): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(delete_multi__application_items, [baseId]);
  // Pass the itemIds in the request body for DELETE method
  return del<DepartmentResponse>(fetch_location_data, { ...credentialsConfig, data: { itemIds } });
};

// update multi applcation 
export const updateMultiApplication = async (baseId: number, appId: number, data: any): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(update_multi_application, [baseId, appId]);
  return post<DepartmentResponse>(fetch_location_data, data, credentialsConfig);
};

export const assignAiInterview = async (baseId: number, data: any): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(assing_interview, [baseId]);
  return post<DepartmentResponse>(fetch_location_data, data, credentialsConfig);
};